export function clearActiveUserSession() {
  localStorage.removeItem("student_id");
  localStorage.removeItem("student_name");
  localStorage.removeItem("role");
  localStorage.removeItem("is_admin");
  localStorage.removeItem("payment_made");
  sessionStorage.clear();
}

export function logoutToLogin(navigate) {
  clearActiveUserSession();
  navigate("/login", { replace: true });
}
